import { useQuery } from 'hooks/useCustomQuery';
import { useSelector } from 'react-redux';
import config from '@/config.json';
import getAvailableNumbersDropdown from '@/API/Company/getAvailableNumbersDropdown';
import getPlatformNumberById from '@/API/PlatformNumber/getPlatformNumberById';

const useGetAvailableNumbersDropdown = (
    currentCompany,
    platformNumber,
    platformId,
    setNumberList,
) => {
    const { requiredScope: accountScope } = useSelector((state) => state.login);
    return useQuery({
        queryKey: ['availableNumbers', platformId, platformNumber?.numberID],
        queryFn: async () => {
            try {
                const res = await getAvailableNumbersDropdown(
                    currentCompany,
                    platformId,
                );

                var userNumber;
                if (platformNumber?.numberID) {
                    try {
                        const currentPlatformNumber =
                            await getPlatformNumberById(
                                platformNumber.numberID,
                                platformId,
                                accountScope,
                            );

                        userNumber = {
                            id: currentPlatformNumber?.numberID,
                            telephoneNumber:
                                currentPlatformNumber?.trunkType === null ||
                                currentPlatformNumber?.trunkType === ''
                                    ? `+${currentPlatformNumber?.telephoneNumber}`
                                    : `+${currentPlatformNumber?.telephoneNumber} - ${currentPlatformNumber?.trunkType}`,
                            numberID: currentPlatformNumber?.numberID,
                            trunkType: currentPlatformNumber?.trunkType,
                        };
                    } catch (error) {
                        console.error('Error fetching current number:', error);
                        throw error;
                    }
                }
                const availableNumbers = (res || []).map((number) => ({
                    ...number,
                    telephoneNumber: `+${number.telephoneNumber} - ${number.trunkType == '' ? 'No Trunk Assigned' : number.trunkType}`,
                }));
                const hasCurrentNumber = availableNumbers?.some(
                    (number) => number.numberID === platformNumber?.numberID,
                );
                const currentNumber =
                    platformNumber?.numberID && userNumber && !hasCurrentNumber
                        ? [userNumber]
                        : [];
                const allNumbers = availableNumbers
                    .concat({
                        id: 'null',
                        telephoneNumber: config.notAllocated.dropdown,
                    })
                    ?.sort((a, b) =>
                        a.telephoneNumber?.localeCompare(b.telephoneNumber),
                    )
                    .concat(currentNumber);
                setNumberList(allNumbers);
                return allNumbers;
            } catch (error) {
                console.error('Error fetching available numbers:', error);
                throw error;
            }
        },
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0,
    });
};

export default useGetAvailableNumbersDropdown;
